import { render, staticRenderFns } from "./IconInstagram.vue?vue&type=template&id=00b46536&scoped=true"
var script = {}
import style0 from "./IconInstagram.vue?vue&type=style&index=0&id=00b46536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b46536",
  null
  
)

export default component.exports